<template>
  <div v-if="$auth.loggedIn && shareStatusDialog">
    <v-dialog
      v-model="shareStatusDialog"
      transition="dialog-top-transition"
      max-width="800"
      persistent
    >
      <v-card
        :class="$breakpoint.smAndDown ? 'px-2' : 'px-3'"
        class="pt-6"
        light
      >
        <v-btn
          small
          icon
          fab
          absolute
          :loading="loading"
          style="right: 0; top: 0"
          @click="closeShareStatusModal()"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card-title
          class="black--text pa-0 lh-1_5 mb-3 mt-2 font-weight-bold"
        >
          <div style="word-break: normal; font-size: 16px">
            Now share your referral code with your friends and earn hefty
            bonuses in a few simple clicks!
          </div>
        </v-card-title>
        <v-card-text class="px-0 py-0">
          <iframe
            class="share-status-video"
            :src="shareStatusModalVideo"
            title="YouTube video player"
            frameborder="0"
            allow=" autoplay; picture-in-picture"
            allowfullscreens
            loading="lazy"
          ></iframe>
        </v-card-text>

        <v-card-actions class="py-4 px-0 d-flex btn-justify">
          <v-btn
            v-if="shareButton"
            color="primary white--text"
            @click="share()"
          >
            Share Now
            <v-icon>mdi-share</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import constants from '@/constant'
import service from '@/services/apiService'
export default {
  props: {
    shareButton: { type: Boolean, default: false, required: false }
  },
  data() {
    return {
      shareStatusDialog: false,
      loading: false,
      shareStatusModalVideo: constants.shareStatusModalVideo,
      shareModalDateRange: constants.shareModalDateRange
    }
  },
  async mounted() {
    try {
      const userRegistrationData = await service.apiCallWithHeaderUsingGet(
        '/v2/getreferralpopup'
      )
      if (
        userRegistrationData &&
        userRegistrationData.status === 200 &&
        userRegistrationData.data &&
        userRegistrationData.data.data &&
        userRegistrationData.data.data[0] &&
        userRegistrationData.data.data[0].dontShowAgain === false
      ) {
        // const todysdate = this.$moment(new Date(), 'DD/MM/YYYY').format(
        //   'DD/MM/YYYY'
        // )
        const registrationDate = this.$moment(
          new Date(userRegistrationData.data.data[0].popupon),
          'DD/MM/YYYY'
        ).format('DD/MM/YYYY')

        // const aftersomedays = this.$moment(registrationDate, 'DD/MM/YYYY')
        //   .add(this.shareModalDateRange, 'days')
        //   .format('DD/MM/YYYY')

        const pickDate = this.$moment(registrationDate.toString(), 'DD/MM/YYYY')
        const dateDiff = this.$moment.duration(this.$moment().diff(pickDate))
        const diffDays = dateDiff.days()
        // console.log(registrationDate)
        // console.log(todysdate)
        // console.log(diffDays)
        // console.log(this.shareModalDateRange)
        // console.log(diffDays > this.shareModalDateRange)
        if (diffDays > this.shareModalDateRange) {
          this.shareStatusDialog = true
          await service.apiCallWithHeader('/v2/updatereferralpopup', {
            dontShowAgain: false
          })
        }
      } else if (
        userRegistrationData.data &&
        userRegistrationData.data.data &&
        userRegistrationData.data.data.length === 0
      ) {
        this.shareStatusDialog = true
        await service.apiCallWithHeader('/v2/updatereferralpopup', {
          dontShowAgain: false
        })
      }
    } catch (err) {
      console.log(err)
    }

    // const shareModalCookieDate = this.getCookie('shareModalDate')
    // if (shareModalCookieDate) {
    //   const diffTime = this.$moment.duration(
    //     this.$moment().diff(shareModalCookieDate)
    //   )
    //   const days = parseInt(diffTime.asDays())
    //   if (days >= this.shareModalDateRange) {
    //     const todayDate = new Date()
    //     document.cookie = `shareModalDate=${todayDate}`
    //     this.shareStatusDialog = true
    //   } else {
    //     this.shareStatusDialog = false
    //   }
    // } else {
    //   const todayDate = new Date()
    //   document.cookie = `shareModalDate=${todayDate}`
    //   this.shareStatusDialog = true
    // }
  },
  methods: {
    getCookie(name) {
      const cookieArr = document.cookie.split(';')
      for (let i = 0; i < cookieArr.length; i++) {
        if (cookieArr[i].includes(name)) {
          const abDate = cookieArr[i].split(`${name}=`)
          if (abDate && abDate.lastItem) {
            return abDate.lastItem
          }
        }
      }
      return null
    },

    closeShareStatusModal() {
      this.shareStatusDialog = false
    },
    share() {
      this.$store.dispatch('share/share')
    }
  }
}
</script>

<style lang="scss" scoped>
.share-status-video {
  width: 100%;
  height: 300px;
}
.btn-justify {
  justify-content: end;
}
</style>
